import useToast from '../hooks/use-toast';

// Create a global toast instance
let toastInstance: ReturnType<typeof useToast> | null = null;

export const setToastInstance = (instance: ReturnType<typeof useToast>) => {
  toastInstance = instance;
};

interface ToastOptions {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success';
}

// Generic toast function with custom title and description
export const showToast = (options: ToastOptions) => {
  console.log('Toast called:', options, 'Instance:', !!toastInstance);
  if (toastInstance) {
    toastInstance.toast(options);
  } else {
    console.error('Toast called but no instance available:', options);
  }
};

export const toast = {
  // Generic toast with custom options
  show: showToast,

  error: (message: string) => {
    console.log('Toast error called:', message, 'Instance:', !!toastInstance);
    if (toastInstance) {
      toastInstance.toast({
        title: 'Error',
        description: message,
        variant: 'destructive',
      });
    } else {
      console.error(message);
    }
  },
  success: (message: string) => {
    console.log('Toast success called:', message, 'Instance:', !!toastInstance);
    if (toastInstance) {
      toastInstance.toast({
        title: 'Success',
        description: message,
        variant: 'success',
      });
    } else {
      console.log(message);
    }
  },
  info: (message: string) => {
    console.log('Toast info called:', message, 'Instance:', !!toastInstance);
    if (toastInstance) {
      toastInstance.toast({
        title: 'Info',
        description: message,
        variant: 'default',
      });
    } else {
      console.log(message);
    }
  },
};
